export default __webpack_public_path__ + "static/media/error-404.33fdf327.png";